export BaseRepository from "./base.repository";
export UserRepository from "./user.repository";
export CompanyRepository from "./company.repository";
export RuntimeRepository from "./runtime.repository";
export PaymentRepository from "./payment.repository";
export ProductRepository from "./product.repository";
export SefazAcronymsRepository from "./sefaz-acronyms.repository";
export CustomerRepository from "./customer.repository";
export AccountRepository from "./account.repository";
export AccountingZipRepository from "./accounting-zip.repository";
export SaleRepository from "./sale.repository";
export CategoryRepository from "./category.repository";
export BarcodeRepository from "./barcode.repository";
export StockOperationsRepository from "./stock-operations.repository";
export CashRegisterRepository from "./cash-register.repository";
export PlanRepository from "./plan.repository";
export PaymentInfoRepository from "./payment-info.repository";
export DeviceRepository from "./device.repository";
export ErrorBoundariesRepository from "./error-boundaries.repository";
export OptionalGroupRepository from "./optional-group.repository";
export InvoicesBillingRepository from "./invoices-billing.repository";
export InvoiceAccountantAreaRepository from "./invoice-accountant-area.repository";
export DiscountRepository from "./discount.repository";
export VariationRepository from "./variation.repository";
export ApplicationRepository from "./application.repository";
export LowStockReportRepository from "./low-stock-report.repository";
export ProductSalesReportRepository from "./product-sales-report.repository";
export WebhookRepository from "./webhook.repository";
export NewSaleReportRepository from "./new-sale-report.repository";
export DevolutionReportRepository from "./devolution-report.repository";
export DevolutionSellableReportRepository from "./devolution-sellable-report.repository.js";
export PaymentsReportRepository from "./payments-report.repository.js";
export OptionalSalesReportRepository from "./optional-sales-report.repository.js";
export OrderIntegration from "./order-integration.repository";
export OmsRepository from "./oms.repository";



// WEBPACK FOOTER //
// ./src/core/repository/index.js